import { nextIntRange } from "../rng/index"
import type { RNGConfig } from "../rng/RNGConfig.type"

export default function randomColorInt(rng : RNGConfig) {
  return nextIntRange(0x0000000, 0xffffff, rng)
}